import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import formatNumber from 'flarum/common/utils/formatNumber';
import { badgeUrl } from '../utils';
import { fullDate, shortDate } from '../../../utils/dates';
import { t } from '../../../utils/settings';
/**
 * Um emblema em cartão: o ícone grande na
 * cor do tipo (ouro, prata, bronze) à esquerda e, ao lado, o nome, a
 * descrição e, conforme o lugar, quantas pessoas o ganharam ou quando a
 * pessoa do perfil o ganhou. O cartão inteiro é o link.
 */
export default class BadgeCard extends Component {
  view() {
    const {
      badge,
      username,
      timesGranted,
      grantedAt,
      owned,
      showCount,
      className
    } = this.attrs;
    const type = badge.type() || 'bronze';
    return m(Link, {
      className: classList('CanelaBadgeCard', `CanelaBadgeCard--${type}`, className, {
        'CanelaBadgeCard--owned': owned
      }),
      href: badgeUrl(badge, username)
    }, m("span", {
      className: "CanelaBadgeCard-contents"
    }, m("span", {
      className: `CanelaBadgeCard-icon CanelaBadgeCard-icon--${type}`,
      title: t(`badges.types.${type}`),
      "aria-hidden": "true"
    }, m(Icon, {
      name: badge.icon() || 'fas fa-certificate'
    })), m("span", {
      className: "CanelaBadgeCard-info"
    }, m("span", {
      className: "CanelaBadgeCard-name"
    }, badge.name(), !!timesGranted && timesGranted > 1 && m("span", {
      className: "CanelaBadgeCard-times"
    }, "\xD7", timesGranted)), badge.description() && m("span", {
      className: "CanelaBadgeCard-description"
    }, badge.description()), this.footer(showCount, grantedAt))), owned && m("span", {
      className: "CanelaBadgeCard-owned",
      title: t('badges.owned')
    }, m(Icon, {
      name: "fas fa-check"
    })));
  }
  footer(showCount, grantedAt) {
    if (grantedAt) {
      return m("time", {
        className: "CanelaBadgeCard-meta",
        datetime: grantedAt.toISOString(),
        title: fullDate(grantedAt)
      }, t('badges.granted_on', {
        date: shortDate(grantedAt)
      }));
    }
    if (showCount) {
      const count = this.attrs.badge.grantCount() || 0;
      return m("span", {
        className: "CanelaBadgeCard-meta"
      }, t('badges.awarded', {
        count,
        number: formatNumber(count)
      }));
    }
    return null;
  }
}
flarum.reg.add('ramon-canela', 'forum/features/badges/components/BadgeCard', BadgeCard);